import styled, { css } from 'styled-components';

export const SliderContainer = styled.div`
  flex: 1;
  box-sizing: border-box;
  padding: 0 0.5rem;
  
  .input-range__label-container{
    font-family: ${(props) => props.theme.fonts.alt};
    color: black;
  }

  .input-range__slider{
    background: black;
    border-color: black;
  }
  .input-range__track--active{
    background: black;
  }
  .input-range__label--min, .input-range__label--max{
    display: none;
  }
`

export const Label = styled.div`
  font-family: ${(props) => props.theme.fonts.alt};
  text-transform: uppercase;
  font-size: 0.75rem;
  display: none;
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 0.75rem;
`;

export const Title = styled.div`
  font-family: ${(props) => props.theme.fonts.alt};
  text-transform: uppercase;
  margin-bottom: 1rem;
`;

const Wrapper = styled.div`
  width: 100%;
  margin-top: 2rem;
  overflow: hidden;
  padding-bottom: 1rem;
  padding-right: 0.5rem;
`;

export default Wrapper;